import { render, staticRenderFns } from "./TemplateModal.vue?vue&type=template&id=058669fd&scoped=true"
import script from "./TemplateModal.vue?vue&type=script&lang=js"
export * from "./TemplateModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateModal.vue?vue&type=style&index=0&id=058669fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058669fd",
  null
  
)

export default component.exports